export const permission_routes = [
  {
    path: "/permissions",
    component: () => import("../Main.vue"),
    name: "Permissões"
  }
];

export default {};
